import React, { useEffect } from 'react';
import { useIsAfterInitialMount } from '../../utilities/use-is-after-initial-mount.js';
function AfterInitialMount(_ref) {
  var children = _ref.children,
    onMount = _ref.onMount,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback;
  var isMounted = useIsAfterInitialMount();
  var content = isMounted ? children : fallback;
  useEffect(function () {
    if (isMounted && onMount) {
      onMount();
    }
  }, [isMounted, onMount]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, content);
}
export { AfterInitialMount };